module.exports = __webpack_public_path__ + "img/cake.72ff084f.svg";